import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import {
  routerReducer,
  RouterReducerState,
  StoreRouterConnectingModule,
} from '@ngrx/router-store';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { environment } from '~env';
import { SharedEffects } from '~shared/store/shared.effects';
import {
  ISharedState,
  sharedReducer,
  sharedStateKey,
} from '~shared/store/shared.reducer';

export interface IAppState {
  readonly router: RouterReducerState;
  readonly [sharedStateKey]: ISharedState;
}

export const storeReducer: ActionReducerMap<IAppState> = {
  router: routerReducer,
  [sharedStateKey]: sharedReducer,
};

@NgModule({
  imports: [
    StoreModule.forRoot(storeReducer),
    StoreRouterConnectingModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    EffectsModule.forRoot([SharedEffects]),
  ],
})
export class AppStoreModule {}
